import React from 'react';
import { connect } from 'react-redux';
import _find from 'lodash/find';
import _get from 'lodash/get';
import _parseInt from 'lodash/parseInt';
// Custom
import { deviceDataShape } from 'constants/PropTypesShapes';
import { getHocDisplayName } from 'utils/Tools';

const withDeviceData = (deviceIdPath) => (WrappedComponent) => {
  const WithDeviceData = ({ deviceData, ...otherProps }) => (
    <WrappedComponent deviceData={deviceData} {...otherProps} />
  );

  WithDeviceData.displayName = getHocDisplayName('WithDeviceData', WrappedComponent);

  WithDeviceData.propTypes = {
    deviceData: deviceDataShape,
  };

  WithDeviceData.defaultProps = {
    deviceData: null,
  };

  const mapStateToProps = (state, ownProps) => ({
    deviceData: _find(state.deviceData.elements, ['id', _parseInt(_get(ownProps, deviceIdPath))]),
  });

  return connect(
    mapStateToProps,
    null,
  )(WithDeviceData);
};

export default withDeviceData;



// WEBPACK FOOTER //
// ./routes/app/assets/hocs/WithDeviceData.js